// frontend/src/components/games/sudoku/SudokuDifficultySelector.tsx

import { SUDOKU_DIFFICULTIES, SudokuDifficulty } from './sudokuConstants';

interface SudokuDifficultySelectorProps {
  current: SudokuDifficulty;
  onSelect: (difficulty: SudokuDifficulty) => void;
}

const ORDER: SudokuDifficulty[] = ['easy', 'medium', 'hard'];

export function SudokuDifficultySelector({ current, onSelect }: SudokuDifficultySelectorProps) {
  return (
    <div className="sudoku-difficulty-selector">
      {ORDER.map((key) => (
        <button
          key={key}
          type="button"
          className={`sudoku-difficulty-btn ${current === key ? 'active' : ''}`}
          onClick={() => onSelect(key)}
        >
          {SUDOKU_DIFFICULTIES[key].label}
        </button>
      ))}
    </div>
  );
}
